"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBasePath = void 0;
const getBasePath = (basePath) => {
    const authorizedBasePath = `${basePath}/api/v1`;
    const unauthorizedBasePath = `${basePath}/v1`;
    const publicBasePath = `${basePath}`;
    return Object.freeze({
        ACCOUNTS: `${authorizedBasePath}/accounts`,
        PORTFOLIOS: `${authorizedBasePath}/portfolios`,
        ADMIN: `${authorizedBasePath}/admin`,
        ATTENDEES: `${authorizedBasePath}/attendees`,
        AUTH: {
            LOGIN: `${authorizedBasePath}/auth/login`,
            LOGOUT: `${authorizedBasePath}/auth/logout`,
            TOKEN_REFRESH: `${authorizedBasePath}/auth/token-refresh`,
            RESET_PASSWORD: `${basePath}/v1/auth/password-reset-request`,
        },
        CONNECTIONS: `${authorizedBasePath}/users/connections`,
        EVENTS: `${authorizedBasePath}/events`,
        PROFILE: `${authorizedBasePath}/users/profile`,
        USERS: `${authorizedBasePath}/users`,
        SESSIONS: `${authorizedBasePath}/sessions`,
        TRACKS: `${authorizedBasePath}/tracks`,
        EXHIBITIONS: `${authorizedBasePath}/exhibitions`,
        USER_EVENTS: `${authorizedBasePath}/users/events`,
        REGISTER: `${basePath}/v1/register`,
        YOUTUBE: `${authorizedBasePath}/sdk/zoom/youtube`,
        ZOOM: {
            SIGNATURE: `${authorizedBasePath}/sdk/zoom/signature`,
            CLIENT: `${authorizedBasePath}/sdk/zoom/client`,
        },
        MEETINGS_USERS_API_KEY: `${authorizedBasePath}/users/meetings`,
        LOCATION_API_KEY: `${authorizedBasePath}/locations`,
        MEETINGS_API_KEY: `${authorizedBasePath}/meetings`,
        POSTS: `${authorizedBasePath}/posts`,
        LINKEDIN_IMPORT_PROFILE: `${authorizedBasePath}/linkedin/authorization`,
        ACTIONS_EXHIBITIONS: `${authorizedBasePath}/actions/exhibitions`,
        ACTIONS_ATTENDEES: `${authorizedBasePath}/actions/profiles`,
        YOUTUBE_SDK_API: `${authorizedBasePath}/sdk/zoom/youtube`, // Remove zoom from path once changed in backend
        DOCUMENTS: `${authorizedBasePath}/documents`,
        LOCATIONS: `${authorizedBasePath}/locations`,
        PAGES: `${authorizedBasePath}/pages`,
        ACTIONS_SESSIONS: `${authorizedBasePath}/actions/sessions`,
        TERMS_URL: "https://hubs101.com/terms-of-use",
        PRIVACY_URL: "https://hubs101.com/privacy-policy",
        VERSIONS: `${basePath}/versions`,
        PASSWORD_ACTIVATION: `${basePath}/v1/activation`,
        VIMEO_VIEW: `${authorizedBasePath}/sdk/vimeo/mobile`,
        NOTES: `${authorizedBasePath}/users/notes`,
        MEETINGS_ARRANGE: `${authorizedBasePath}/meetings/arrange`,
        USER_NOTIFICATIONS: `${authorizedBasePath}/users/notifications`,
        NOTIFICATIONS: `${authorizedBasePath}/notifications`,
        GROUPS: `${authorizedBasePath}/groups`,
        OPTIONS: `${authorizedBasePath}/options`,
        TICKETS: `${authorizedBasePath}/tickets`,
        DISCOUNTS: `${authorizedBasePath}/discounts`,
        PAYMENT_ACCOUNTS: `${authorizedBasePath}/payment-accounts`,
        STREAMS: `${authorizedBasePath}/streams`,
        ACCOUNT_TRIAL: `${unauthorizedBasePath}/accounts/trial`,
        INVITATION: `${unauthorizedBasePath}/invitation`,
        PUBLIC_INVITATIONS: `${unauthorizedBasePath}/invitations`,
        BOOKINGS: `${authorizedBasePath}/bookings`,
        PUBLIC_BOOKINGS: `${unauthorizedBasePath}/bookings`,
        ACTIONS_EVENTS: `${authorizedBasePath}/actions/events`,
        ACTIONS_ATTENDEE: `${authorizedBasePath}/actions/attendees`,
        PUBLIC_TICKETS: `${publicBasePath}/tickets`,
        PUBLIC_GROUPS: `${publicBasePath}/groups`,
        PUBLIC_ACCOUNTS: `${publicBasePath}/accounts`,
        PUBLIC_EVENTS: basePath ? `${publicBasePath}/events` : "/events",
        PUBLIC_OFFERS: `${publicBasePath}/offers`,
        PUBLIC_OFFERS_UPLOAD: `${publicBasePath}/v1/offers`,
    });
};
exports.getBasePath = getBasePath;
